import { ESuggestType, TSuggestElement } from '../types/factFinder'
import { ESuggestTypeSearcApi, TSuggestResultSearchApi } from '../types/searchApi'

const suggestTypeMap = {
  [ESuggestTypeSearcApi.BRAND]: ESuggestType.BRAND,
  [ESuggestTypeSearcApi.PRODUCT_LINE]: ESuggestType.BRAND,
  [ESuggestTypeSearcApi.CATEGORY]: ESuggestType.CATEGORY,
  [ESuggestTypeSearcApi.SINGLE_PRODUCT]: ESuggestType.PRODUCT,
}

/**
 * maps suggest response body from search-api-gateway to response from factfinder api
 */
export const mapSuggestResponseBody = (data: TSuggestResultSearchApi): TSuggestElement[] => {
  return data.suggestions.map((suggestion) => {
    const suggestElement: TSuggestElement = {
      name: suggestion.text,
      type: suggestTypeMap[suggestion.suggest_type],
    }

    if (suggestion.base_product_no) {
      suggestElement.attributes ||= {}
      suggestElement.attributes.masterId = suggestion.base_product_no
    }
    if (suggestion.category_path) {
      suggestElement.attributes ||= {}
      suggestElement.attributes.categoryPath = suggestion.category_path
    }

    return suggestElement
  })
}
